<template>
  <div class="ps-update-page" :class="{ 'is-ai-parsing': jxing }">
    <AiParseLoading
      v-if="jxing"
      title="正在智能识别思政教育工作室申报书"
      @cancel="cancelAiParse"
    />
    <div class="ps-form-layout">
      <aside class="ps-sidebar">
        <div class="ps-side-card">
          <div class="ps-side-title">填写步骤</div>
          <button
            v-for="(sec, i) in sections"
            :key="sec.id"
            type="button"
            class="ps-step-item"
            :class="sectionStepClass(i)"
            @click="editGo(i)"
          >
            <span class="ps-step-label">{{ sec.title }}</span>
            <span class="ps-step-mark">{{ sectionStepMark(i) }}</span>
          </button>
          <div class="ps-side-hint">
            点击步骤切换模块，带 <b style="color: #ef4444">*</b> 的为必填项
          </div>
        </div>
      </aside>

      <div class="ps-content">
        <div class="ps-status-bar">
          <div class="ps-status-block">
            <span class="ps-status-label">当前状态</span>
            <StatusBadge status="0" text="AI导入" type="blue" />
          </div>
          <div class="ps-status-block">
            <span class="ps-status-label">正在编辑</span>
            <span class="ps-status-value warn">识别结果编辑</span>
          </div>
          <div style="flex: 1"></div>
          <button type="button" class="ps-btn ps-btn--white" @click="saveDraft">
            💾 暂存
          </button>
          <button type="button" class="ps-btn ps-btn--blue" @click="option()">
            ✉ 提交
          </button>
          <button type="button" class="ps-btn ps-btn--white" @click="goBack">
            ↩ 返回
          </button>
        </div>

        <div
          class="ps-form-card"
          :class="{ 'is-origin-form': activeSection === 0 }"
        >
          <div v-show="activeSection === 0" id="baseInfo" class="ps-origin-base-embed">
            <BaseInfo
              :oldInfos="baseInfo"
              ref="baseInfoRef"
              @isbj="isbj"
              :isAdd="isAdd"
            />
          </div>
          <div v-show="activeSection === 1" id="teamInfo" class="ps-list-embed">
            <TeamInfo
              :oldInfos="baseInfo"
              :isbj="isbjs"
              ref="teamInfoRef"
              :cardTitle="baseInfoTitle"
            />
          </div>
          <div v-show="activeSection === 2" id="teachAdd" class="ps-list-embed">
            <teachAdd :oldInfos="baseInfo" ref="teachAddRef" :isbj="isbjs" />
          </div>
          <div v-show="activeSection === 3" id="budget" class="ps-list-embed">
            <Budget
              :oldInfos="baseInfo"
              :isbj="isbjs"
              ref="budgetRef"
              :cardTitle="budgetTitle"
            />
          </div>
          <div
            v-show="activeSection === 4"
            id="capitalExpenditure"
            class="ps-list-embed"
          >
            <CapitalExpenditure
              :oldInfos="baseInfo"
              ref="capitalExpenditureRef"
              :isbj="isbjs"
              :cardTitle="capitalExpenditureTitle"
            />
          </div>
          <div
            v-show="activeSection === 5"
            id="scientificeAdd"
            class="ps-list-embed"
          >
            <scientificeAdd
              :oldInfos="baseInfo"
              ref="scientificeAddRef"
              :isbj="isbjs"
            />
          </div>
          <div v-show="activeSection === 6" id="result" class="ps-list-embed">
            <Result :oldInfos="baseInfo" ref="resultRef" :isbj="isbjs" />
          </div>
          <div v-show="activeSection === 7" id="activity" class="ps-list-embed">
            <Activity :oldInfos="baseInfo" :isbj="isbjs" ref="activityRef" />
          </div>
          <div
            v-show="activeSection === 8"
            id="teamBuilding"
            class="ps-list-embed"
          >
            <TeamBuilding
              :oldInfos="baseInfo"
              :isbj="isbjs"
              ref="teamBuildingRef"
            />
          </div>
          <div
            v-show="activeSection === 9"
            id="practiceBase"
            class="ps-list-embed"
          >
            <PracticeBase
              :oldInfos="baseInfo"
              :isbj="isbjs"
              ref="practiceBaseRef"
            />
          </div>
          <div v-show="activeSection === 10" id="honor" class="ps-list-embed">
            <Honor :oldInfos="baseInfo" :isbj="isbjs" ref="honorRef" />
          </div>
          <div v-show="activeSection === 11" id="brand" class="ps-list-embed">
            <Brand :oldInfos="baseInfo" :isbj="isbjs" ref="brandRef" />
          </div>
        </div>

        <div class="ps-footer-bar">
          <div class="ps-footer-tip">
            💡 AI 已识别申报书内容，请核对后按步骤完善各模块
          </div>
          <div class="ps-footer-actions">
            <button type="button" class="ps-btn ps-btn--white" @click="editPrev">
              ← 上一步
            </button>
            <button type="button" class="ps-btn ps-btn--blue" @click="editNext">
              下一步 →
            </button>
            <button type="button" class="ps-btn ps-btn--blue" @click="option()">
              ✉ 提交
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import stepView from "./stepView.vue";
// import step1 from "./step1.vue";

import BaseInfo from "./baseInfo.vue";
import TeamInfo from "./teamInfo.vue";
import Budget from "./budget.vue";
import CapitalExpenditure from "./capitalExpenditure.vue";
import Result from "./result.vue";
import teachAdd from "./teachingAndResearch.vue";
import scientificeAdd from "./scientificeAndResearch.vue";
import activityPlan from "./activityPlan.vue";
import Activity from "./activity.vue";
import TeamBuilding from "./teamBuilding.vue";
import PracticeBase from "./practiceBase.vue";
import Honor from "./honor.vue";
import Brand from "./brand.vue";
import AiParseLoading from "@/components/common/AiParseLoading.vue";
import StatusBadge from "@/components/projectShell/StatusBadge.vue";
import sectionFilledMixin from "@/components/projectShell/sectionFilledMixin.js";
import { getAction, postAction, putAction, deleteAction, postAiChat } from "@/api/index";
import { GZS } from "@/utils/brand.js";
import { emptyDatesToNull, emptyToNull } from "@/utils/time";
import axios from "axios";
export default {
  mixins: [sectionFilledMixin],
  name: "",
  components: {
    // stepView,
    // step1,
    BaseInfo,
    teachAdd,
    TeamInfo,
    Budget,
    CapitalExpenditure,
    scientificeAdd,
    activityPlan,
    Result,
    Activity,
    TeamBuilding,
    PracticeBase,
    Honor,
    Brand,
    AiParseLoading,
    StatusBadge,
  },
  props: {
    editInfo: { type: Object, default: null },
  },
  watch: {
    editInfo: {
      handler(newValue, oldValue) {
        console.log(newValue, "8888888888888888");
        if (newValue !== null) {
          this.baseInfo = newValue;
          // this.id = newValue.id;
          this.$refs.baseInfoRef.info = newValue;
          this.$refs.teamInfoRef.oldInfo = newValue;
          if (this.baseInfo.auditState == 1 || this.baseInfo.auditState == 2) {
            this.isEdit = true;
            this.editInfo.type = "preview";
          } else {
            this.isEdit = false;
            this.editInfo.type = "";
          }
          if (this.isbjs == false) {
            this.isEdit = false;
            this.editInfo.type = "";
          } else {
            // this.isEdit = true;
            // this.editInfo.type = "preview";
          }
          // this.baseInfo.isbjs=true;
        } else {
          this.baseInfo = null;
          this.id = null;
          this.$refs.baseInfoRef.info = null;
          this.$refs.teamInfoRef.oldInfo = null;
          this.isEdit = false;
          this.editInfo.type = "";
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      jxing: true,
      isEdit: false,
      baseInfoTitle: "工作室团队",
      budgetTitle: "工作室资金预算",
      capitalExpenditureTitle: "工作室资金支出",
      sections: [
        {
          title: "工作室基本信息",
          id: "baseInfo",
        },
        {
          title: "工作室团队",
          id: "teamInfo",
        },
        {
          title: "教研情况",
          id: "teachAdd",
        },
        {
          title: "工作室资金预算",
          id: "budget",
        },
        {
          title: "工作室资金支出",
          id: "capitalExpenditure",
        },
        {
          title: "科研情况",
          id: "scientificeAdd",
        },
        // {
        //   title: "活动方案",
        //   id: "activityPlanAdd",
        // },
        {
          title: "标志性成果",
          id: "result",
        },
        {
          title: "思政课程与课程思政大格局",
          id: "activity",
        },
        {
          title: "团队建设",
          id: "teamBuilding",
        },
        {
          title: "思政实践基地",
          id: "practiceBase",
        },
        {
          title: "荣誉",
          id: "honor",
        },
        {
          title: "培育品牌",
          id: "brand",
        },
      ],
      baseInfo: null,
      baseInfos: {},
      id: null,
      activeSection: 0,
      isAction: false,
      isAdd: true,
      isbjs: true,
      jblist: [],
      lblist: [],
      cylist: [],
      gblist: [],
      jdlb: [
        // { text: "校内基地", title: "校内基地" },
        // { text: "校外基地", title: "校外基地" }
      ],
      jdxs: [
        // { text: "线上基地", title: "线上基地" },
        // { text: "线下基地", title: "线下基地" }
      ],
      lylist: [],
      // lylist:[{text:'省补贴',title:'省补贴'},{text:'地方补贴',title:'地方补贴'},{text:'学校自筹',title:'学校自筹'},{text:'其他',title:'其他'}],
      educationlist: [],
      zclist: [],
      contentlist: [],
      lxlist: [],
      hzdwlist: [],
      fileId: "",
      btlist: [],
      jklist: [],
      isSubmit: false,
      draftLoading: false,
      aiChatCancelSource: null,
    };
  },
  computed: {},
  destroyed() {
    window.sessionStorage.removeItem(`step${this.$store.state.user.id}`);
  },
  created() {
    // console.log(this.editInfo, "add1111111");
    // //  this.editInfo=JSON.parse(this.editInfo);
    // if (this.editInfo !== null) {
    //   console.log("1111    created editInfo", this.editInfo);
    //   this.baseInfo = this.editInfo;
    //   // console.log("this.$refs.baseInfoRef.info", this.$refs.baseInfoRef);
    //   // // this.$refs.baseInfoRef.info = this.editInfo;
    //   // this.$refs.teamInfoRef.oldInfo = this.editInfo;
    //   // this.$refs.budgetRef.oldInfo = this.editInfo;
    //   // this.$refs.capitalExpenditureRef.oldInfo = this.editInfo;
    //   // this.$refs.resultRef.oldInfo = this.editInfo;
    //   // this.$refs.teamBuildingRef.oldInfo = this.editInfo;
    //   // this.$refs.practiceBaseRef.oldInfo = this.editInfo;
    //   // this.$refs.honorRef.oldInfo = this.editInfo;
    //   // this.$refs.brandRef.oldInfo = this.editInfo;
    // }
  },
  methods: {
    ensureList(list, msg) {
      if (!list || !list.length) {
        this.$message.info(msg);
        return false;
      }
      return true;
    },
    async getjdxs() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=base_form"
        );
        // console.log(res);
        if (res.code == 200) {
          this.jdxs = res.result;
        }
      } catch (error) {
        console.error("getedu 出错:", error);
      }
    },
    async getbtlist() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=szkcandkcsz"
        );
        // console.log(res);
        if (res.code == 200) {
          this.btlist = res.result;
        }
      } catch (error) {
        console.error("getbt 出错:", error);
      }
      // getAction('/baseCommon/getDictItemsByCode?code=szkcandkcsz').then(res => {
      //   if (res.code == 200) {
      //     this.btlist = res.result;
      //   }
      // })
    },
    isbt(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.btlist.length > 0) {
          let foundItem = this.btlist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    async getjklist() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=jk_type"
        );
        // console.log(res);
        if (res.code == 200) {
          this.jklist = res.result;
        }
      } catch (error) {
        console.error("getjk 出错:", error);
      }
      // getAction('/baseCommon/getDictItemsByCode?code=szkcandkcsz').then(res => {
      //   if (res.code == 200) {
      //     this.btlist = res.result;
      //   }
      // })
    },
    isjk(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.jklist.length > 0) {
          let foundItem = this.jklist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    async getjdlb() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=base_type"
        );
        // console.log(res);
        if (res.code == 200) {
          this.jdlb = res.result;
        }
      } catch (error) {
        console.error("getedu 出错:", error);
      }
    },
    async getedu() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=education"
        );
        // console.log(res);
        if (res.code == 200) {
          this.educationlist = res.result;
        }
      } catch (error) {
        console.error("getedu 出错:", error);
      }
    },
    async getlxlist() {
      try {
        let schooltype = this.$store.state.user.schoolType;
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=" +
            schooltype +
            "_researchsituation"
        );
        // console.log(res);
        if (res.code == 200) {
          this.lxlist = res.result;
        }
      } catch (error) {
        console.error("getedu 出错:", error);
      }

      // getAction("/baseCommon/getDictItemsByCode?code="+schooltype+"_researchsituation").then(
      //   (res) => {
      //     if (res.code == 200) {
      //       this.lxlist = res.result;
      //     }
      //   }
      // );
    },
    islx(sj) {
      if (sj == null || sj === "") {
        return "";
      }
      const raw = String(sj);
      if (this.lxlist.length > 0) {
        let foundItem = this.lxlist.find((item) => item.text === raw);
        if (foundItem) return foundItem.text;
        // AI 文案可能与字典不完全一致，按关键词回落
        if (raw.indexOf("项目完成数") !== -1) {
          const p = this.lxlist.find(
            (item) => item.text && item.text.indexOf("项目完成数") !== -1
          );
          if (p) return p.text;
        }
        if (raw.indexOf("文章") !== -1 || raw.indexOf("发表") !== -1) {
          const a = this.lxlist.find(
            (item) =>
              item.text &&
              (item.text.indexOf("文章") !== -1 ||
                item.text.indexOf("发表") !== -1)
          );
          if (a) return a.text;
        }
        // 保留原文，避免 type 变空导致表格/校验异常
        return raw;
      }
      return raw;
    },
    async gethzdwlist() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=sz_company"
        );
        console.log(res);
        if (res.code == 200) {
          this.hzdwlist = res.result;
        }
      } catch (error) {
        console.error("getly 出错:", error);
      }
      //  getAction("/baseCommon/getDictItemsByCode?code=sz_company").then(
      //   (res) => {
      //     if (res.code == 200) {
      //       this.hzdwlist = res.result;
      //     }
      //   }
      // );
    },
    ishzdw(sj) {
      if (sj == "") {
        return ["", ""];
      } else {
        if (this.hzdwlist.length > 0) {
          let foundItem = this.hzdwlist.find((item) => item.text === sj);

          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["其他", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    async getly() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=capital_source"
        );
        console.log(res);
        if (res.code == 200) {
          this.lylist = res.result;
        }
      } catch (error) {
        console.error("getly 出错:", error);
      }
    },
    isedu(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.educationlist.length > 0) {
          let foundItem = this.educationlist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    async getzc() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=professional"
        );
        if (res.code == 200) {
          this.zclist = res.result;
        }
      } catch (error) {
        console.error("getxl 出错:", error);
      }
    },
    iszc(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.zclist.length > 0) {
          let foundItem = this.zclist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    async getcontent() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=engaged_content"
        );
        if (res.code == 200) {
          this.contentlist = res.result;
        }
      } catch (error) {
        console.error("getcontent 出错:", error);
      }
    },
    iscontent(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.contentlist.length > 0) {
          let foundItem = this.contentlist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    iscyly(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.cylist.length > 0) {
          let foundItem = this.cylist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    async getgb() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=achievement_level"
        );
        if (res.code == 200) {
          this.gblist = res.result;
        }
      } catch (error) {
        console.error("getlb 出错:", error);
      }
      //  getAction("/baseCommon/getDictItemsByCode?code=achievement_level",).then((res) => {
      // 	if (res.code == 200) {
      // this.gblist=res.result;
      // this.gblist = [
      //   { text: "国家级", title: "国家级" },
      //   { text: "省级", title: "省级" },
      //   { text: "市级", title: "市级" },
      //   { text: "县级", title: "县级" },
      //   { text: "校级", title: "校级" },
      //   { text: "其他", title: "其他" }
      // ];
      // console.log(this.gblist,"111111");
      // 	}
      // });
    },
    async getcgjb() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=build_name"
        );
        if (res.code == 200) {
          this.jblist = res.result;
        }
      } catch (error) {
        console.error("getlb 出错:", error);
      }
      // getAction("/baseCommon/getDictItemsByCode?code=build_name").then(
      //   (res) => {
      //     if (res.code == 200) {
      // this.jblist = res.result;
      // this.jblist = [
      //   { text: "青年教师培养培训数量", title: "青年教师培养培训数量" },
      //   { text: "青年教师教学基本功比赛", title: "青年教师教学基本功比赛省级" },
      //   { text: "教学能力大赛", title: "教学能力大赛" },
      //   { text: "班主任能力大赛", title: "班主任能力大赛" },
      //   { text: "思想政治工作研讨会", title: "思想政治工作研讨会" },
      //   { text: "校级以上科研课题研究数量", title: "校级以上科研课题研究数量" },
      //   { text: "思政课题研究", title: "思政课题研究" },
      //   { text: "其他", title: "其他" }
      // ];
      //       console.log(this.jblist,"111111");
      //     }
      //   }
      // );
    },
    isjdxs(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.jdxs.length > 0) {
          let foundItem = this.jdxs.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    isjdlb(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.jdlb.length > 0) {
          let foundItem = this.jdlb.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    isly(sj) {
      if (sj == "") {
        return [""];
      } else {
        if (this.lylist.length > 0) {
          let foundItem = this.jblist.find((item) => item.text === sj);

          if (foundItem) {
            return [foundItem.text];
          } else {
            return ["其他"];
          }
        } else {
          return [""];
        }
      }
    },
    ismc(sj) {
      if (sj == "") {
        return ["", ""];
      } else {
        if (this.jblist.length > 0) {
          let foundItem = this.jblist.find((item) => item.text === sj);

          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["其他", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    async getkycgjb() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=kyqkxmjb"
        );
        if (res.code == 200) {
          this.kyjblist = res.result;
        }
      } catch (error) {
        console.error("getcy 出错:", error);
      }
      // getAction("/baseCommon/getDictItemsByCode?code=kyqkxmjb",).then((res) => {
      // 	if (res.code == 200) {
      // 		this.jblist=res.result;
      // 	}
      // });
    },
    iskyjb(sj) {
      if (sj == null || sj === "") {
        return "";
      }
      const raw = String(sj);
      if (this.kyjblist && this.kyjblist.length > 0) {
        let foundItem = this.kyjblist.find((item) => item.text === raw);
        if (foundItem) return foundItem.text;
        return raw;
      }
      return raw;
    },
    async getcylist() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=sz_member_source"
        );
        if (res.code == 200) {
          this.cylist = res.result;
        }
      } catch (error) {
        console.error("getcy 出错:", error);
      }
    },
    async getlb() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=sz_activity_type"
        );
        if (res.code == 200) {
          this.lblist = res.result;
        }
      } catch (error) {
        console.error("getlb 出错:", error);
      }
      // getAction("/baseCommon/getDictItemsByCode?code=sz_activity_type",).then((res) => {
      // 	if (res.code == 200) {
      // 		this.lblist=res.result;
      //     console.log(this.lblist,"111111");
      // 	}
      // });
      // this.lblist = [
      //   { text: "思政精品课程", title: "思政精品课程" },
      //   { text: "思政示范课程", title: "思政示范课程" },
      //   { text: "思政教育案例", title: "思政教育案例" },
      //   { text: "课程思政示范课", title: "课程思政示范课" },
      //   { text: "课程思政教育案例", title: "课程思政教育案例" },
      //   { text: "课堂革命教育案例", title: "课堂革命教育案例" },
      //   { text: "思政大教研活动", title: "思政大教研活动" },
      //   { text: "思政教研与研究", title: "思政教研与研究" },
      //   { text: "思政育人实践活动", title: "思政育人实践活动" },
      //   { text: "其他", title: "其他" }
      // ];
    },
    isgb(sj) {
      if (sj == "") {
        return ["", ""];
      } else {
        // console.log(this.gblist,sj);
        if (this.gblist.length > 0) {
          let foundItem = this.gblist.find((item) => item.text === sj);
          // console.log(foundItem);
          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["其他", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    islb(sj) {
      if (sj == "") {
        return ["", ""];
      } else {
        if (this.lblist.length > 0) {
          let foundItem = this.lblist.find((item) => item.text === sj);

          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["其他", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    extractJsonContent(content) {
      // 正则表达式匹配 JSON 内容
      const pattern = /```json\n([\s\S]*?)\n```/; // /s 修饰符使 . 匹配换行符
      const match = content.match(pattern);
      if (match && match[1]) {
        return match[1].trim(); // 获取匹配到的 JSON 内容并去掉前后空格
      } else {
        return "No JSON content found";
      }
    },
    isbj() {
      // this.baseInfo.isbjs=false;
      // this.editInfo.isbjs=false;
      // console.log(this.editInfo, "2222");
      // this.$set(this.baseInfo, 'isbjs', false);
      // this.$set(this.editInfo, 'isbjs', false);
      // this.$forceUpdate();
      this.isbjs = false;
      // this.editInfo.type='';
      // this.baseInfo.type='';
      // console.log(this.baseInfo)
    },
    syncAiFormData() {
      const baseInfoRef = this.$refs.baseInfoRef;
      if (!this.baseInfo) {
        this.baseInfo = {};
      }
      if (baseInfoRef && baseInfoRef.info) {
        Object.assign(this.baseInfo, baseInfoRef.info);
        if (this.baseInfo.applyYear) {
          this.baseInfo.applyYear = this.isYear(this.baseInfo.applyYear);
        }
        if (baseInfoRef.fileList && baseInfoRef.fileList.length > 0) {
          this.baseInfo.declarationName = baseInfoRef.fileList[0].name;
          this.baseInfo.declarationPath = baseInfoRef.fileList[0].path;
        }
        if (baseInfoRef.fileList1 && baseInfoRef.fileList1.length > 0) {
          this.baseInfo.activityPlanName = baseInfoRef.fileList1[0].name;
          this.baseInfo.activityPlanPath = baseInfoRef.fileList1[0].path;
        }
      }
      return this.baseInfo;
    },
    saveDraft() {
      if (this.draftLoading || this.jxing) return;
      this.draftLoading = true;
      const params = this.buildStudioImportPayload();
      postAction("/aiAuto/saveDraft", params)
        .then((res) => {
          if (res.code == 200 || res.success) {
            this.isSubmit = true;
            this.applyDraftId(res);
            this.$message.success(res.message || "暂存成功");
            this.$nextTick(() => {
              this.$router.replace({ name: "szStudio" }).catch(() => {
                this.$router.push({ name: "szStudio" });
              });
            });
          } else {
            this.$message.error(res.message || "暂存失败");
          }
        })
        .finally(() => {
          this.draftLoading = false;
        });
    },
    formatFoundTime(foundTime) {
      if (!foundTime) return null;
      const dateObj = new Date(foundTime);
      if (isNaN(dateObj.getTime())) return null;
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1;
      const date = dateObj.getDate();
      return `${year}-${month.toString().padStart(2, "0")}-${date
        .toString()
        .padStart(2, "0")}`;
    },
    applyDraftId(res) {
      const id = res && res.result && res.result.id;
      if (!id) return;
      if (!this.baseInfo) this.baseInfo = {};
      this.baseInfo.id = id;
      if (this.$refs.baseInfoRef && this.$refs.baseInfoRef.info) {
        this.$refs.baseInfoRef.info.id = id;
      }
      const userId =
        (this.$store.state.user && this.$store.state.user.id) ||
        this.$store.state.userId;
      if (userId) {
        window.sessionStorage.setItem(`step${userId}`, id);
      }
    },
    buildStudioImportPayload() {
      this.syncAiFormData();
      const payload = { ...(this.baseInfo || {}), applyType: 1 };
      payload.foundTime = this.formatFoundTime(payload.foundTime);
      payload.applyYear = payload.applyYear
        ? this.isYear(payload.applyYear)
        : "";
      emptyDatesToNull(payload);
      if (Array.isArray(payload.sciencelist)) {
        payload.sciencelist.forEach((item) => {
          if (item && item.type && String(item.type).indexOf("项目完成") === -1) {
            item.jxsj = null;
            item.xnjb = null;
            item.zzje = null;
          }
          if (item) {
            item.lxsj = this.ensureFullDate(item.lxsj);
            item.jxsj =
              item.jxsj == null || item.jxsj === ""
                ? null
                : this.ensureFullDate(item.jxsj);
          }
        });
      }
      return payload;
    },
    option() {
      // console.log(this.baseInfo);
      // this.loading = true;
      // let arr = [];
      // arr.push(this.baseInfo.id);
      // let data = {
      //   applyIds: arr
      // };
      // postAction("/lx/lxApply/submitBatch", data).then(res => {
      //   console.log(res);
      //   if (res.code === 200) {
      //     this.$router.push({ name: "szStudio" });
      //   } else {
      //     this.$message.info(res.message);
      //   }
      //   this.loading = false;
      // });
      this.syncAiFormData();
      console.log(this.baseInfo);
      if (
        (this.baseInfo && this.baseInfo.name == "") ||
        this.baseInfo.name == undefined
      ) {
        this.$message.info("请填写工作室名称");
        return false;
      } else if (
        (this.baseInfo && this.baseInfo.applyYear === "") ||
        this.baseInfo.applyYear == undefined
      ) {
        this.$message.info("请选择申报年份");
        return false;
      } else if (
        (this.baseInfo && this.baseInfo.address === "") ||
        this.baseInfo.address == undefined
      ) {
        this.$message.info("请填写工作室地点");
        return false;
      }
      if (
        (this.baseInfo && this.baseInfo.acreage === "") ||
        this.baseInfo.acreage == undefined
      ) {
        this.$message.info("请填写思政教育工作室面积");
        return false;
      } else {
        let telStr = /^(0*[1-9]\d*\.?\d+|[1-9]\d*)$/;
        if (!telStr.test(this.baseInfo.acreage)) {
          this.$message.info("输入的思政教育工作室面积格式不正确");
          return false;
        }
      }
      if (
        (this.baseInfo && this.baseInfo.belongDepartment === "") ||
        this.baseInfo.belongDepartment == undefined
      ) {
        this.$message.info("请填写思政教育工作室所属部门");
        return false;
      }
      if (
        (this.baseInfo && this.baseInfo.foundTime === "") ||
        this.baseInfo.foundTime == undefined
      ) {
        this.$message.info("请选择工作室建设日期");
        return false;
      }
      const hasDeclaration =
        (this.$refs.baseInfoRef &&
          this.$refs.baseInfoRef.fileList &&
          this.$refs.baseInfoRef.fileList.length > 0 &&
          this.$refs.baseInfoRef.fileList[0].path) ||
        (this.baseInfo && this.baseInfo.declarationPath);
      if (!hasDeclaration) {
        this.$message.info("请上传申报书");
        return false;
      }
      if (
        !this.baseInfo.teacherlist ||
        this.baseInfo.teacherlist.length === 0
      ) {
        this.$message.info("请添加团队成员");
        return false;
      }

      if (this.baseInfo.teacherlist.length > 0) {
        const requiredFields = [
          "teacherName",
          "sex",
          "education",
          "professionalTitle",
          "engagedContent",
          "joinYear",
          "izResponse",
          "izDedicated",
          "izPolitical",
          "szMemberSource",
        ];
        for (let i = 0; i < this.baseInfo.teacherlist.length; i++) {
          const item = this.baseInfo.teacherlist[i];

          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "teacherName") {
                this.$message.info(
                  `工作室团队第 ${i + 1} 行的教师姓名没有值，请填写`
                );
                return false; // 退出当前函数，停止进一步处理
              } else if (field == "sex") {
                this.$message.info(
                  `工作室团队第 ${i + 1} 行的教师性别没有值，请填写`
                );
                return false; // 退出当前函数，停止进一步处理
              } else if (field == "education") {
                this.$message.info(
                  `工作室团队第 ${i + 1} 行的学历没有值，请填写`
                );
                return false; // 退出当前函数，停止进一步处理
              } else if (field == "professionalTitle") {
                this.$message.info(
                  `工作室团队第 ${i + 1} 行的职称没有值，请填写`
                );
                return false;
              } else if (field == "engagedContent") {
                this.$message.info(
                  `工作室团队第 ${i + 1} 行的从事内容没有值，请填写`
                );
                return false;
              } else if (field == "joinYear") {
                this.$message.info(
                  `工作室团队第 ${i + 1} 行的加入年份没有值，请填写`
                );
                return false;
              } else if (field == "izResponse") {
                this.$message.info(
                  `工作室团队第 ${i + 1} 行的是否负责人没有值，请填写`
                );
                return false;
              } else if (field == "izDedicated") {
                this.$message.info(
                  `工作室团队第 ${i + 1} 行的是否专岗没有值，请填写`
                );
                return false;
              } else if (field == "izPolitical") {
                this.$message.info(
                  `工作室团队第 ${i + 1} 行的是否思政教师没有值，请填写`
                );
                return false;
              } else if (field == "szMemberSource") {
                this.$message.info(
                  `工作室团队第 ${i + 1} 行的成员来源没有值，请填写`
                );
                return false;
              }
            }
          }
        }
      }

      if (!this.ensureList(this.baseInfo.teachreserchlist, "请添加教研情况"))
        return false;
      if (this.baseInfo.teachreserchlist.length > 0) {
        const requiredFields = ["year", "num"];
        for (let i = 0; i < this.baseInfo.teachreserchlist.length; i++) {
          const item = this.baseInfo.teachreserchlist[i];

          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "year") {
                this.$message.info(
                  `教研情况第 ${i + 1} 行的年份没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "num") {
                this.$message.info(
                  `教研情况第 ${i + 1} 行的数量没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.capitalBudgetinglist, "请添加工作室资金预算"))
        return false;
      if (this.baseInfo.capitalBudgetinglist.length > 0) {
        const requiredFields = ["vintages", "capitalSource", "amount"];
        for (let i = 0; i < this.baseInfo.capitalBudgetinglist.length; i++) {
          const item = this.baseInfo.capitalBudgetinglist[i];

          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "vintages") {
                this.$message.info(
                  `工作室资金预算第 ${i + 1} 行的年份没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "capitalSource") {
                this.$message.info(
                  `工作室资金预算第 ${i + 1} 行的资金来源没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "amount") {
                this.$message.info(
                  `工作室资金预算第 ${i + 1} 行的资金金额没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.capitalPaylist, "请添加工作室资金支出"))
        return false;
      if (this.baseInfo.capitalPaylist.length > 0) {
        const requiredFields = [
          "lxSubsudyFundId",
          "costYear",
          "project",
          "amount",
        ];
        for (let i = 0; i < this.baseInfo.capitalPaylist.length; i++) {
          const item = this.baseInfo.capitalPaylist[i];
          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "lxSubsudyFundId") {
                this.$message.info(
                  `工作室资金支出第 ${i + 1} 行的支出资金来源没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "costYear") {
                this.$message.info(
                  `工作室资金支出第 ${i + 1} 行的支出年份没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "project") {
                this.$message.info(
                  `工作室资金支出第 ${i + 1} 行的支出项目没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "amount") {
                this.$message.info(
                  `工作室资金支出第 ${i + 1} 行的支出金额没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.sciencelist, "请添加科研情况"))
        return false;
      if (this.baseInfo.sciencelist.length > 0) {
        const requiredFields = ["type", "xmmc", "lxdw", "lxsj"];
        const requiredFields1 = [
          "type",
          "xmmc",
          "lxdw",
          "lxsj",
          "jxsj",
          "xnjb",
          "zzje",
        ];
        for (let i = 0; i < this.baseInfo.sciencelist.length; i++) {
          const item = this.baseInfo.sciencelist[i];
          console.log(
            'item.type && item.type.indexOf("项目完成数") != "-1"',
            item.type && item.type.indexOf("项目完成数") != "-1"
          );
          // 检查每个字段是否有值
          if (item.type && item.type.indexOf("项目完成数") != "-1") {
            for (let field of requiredFields1) {
              if (!item[field]) {
                // 如果字段为空，弹出提示并退出循环
                if (field == "type") {
                  this.$message.info(
                    `科研情况第 ${i + 1} 行的类型没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "xmmc") {
                  this.$message.info(
                    `科研情况第 ${i + 1} 行的项目名称没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "lxdw") {
                  this.$message.info(
                    `科研情况第 ${i + 1} 行的立项单位没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "lxsj") {
                  this.$message.info(
                    `科研情况第 ${i + 1} 行的立项时间没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "jxsj") {
                  this.$message.info(
                    `科研情况第 ${i + 1} 行的结项时间没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "xnjb") {
                  this.$message.info(
                    `科研情况第 ${i + 1} 行的项目级别没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "zzje") {
                  if (item[field] != 0) {
                    this.$message.info(
                      `科研情况第 ${i + 1} 行的资助金额没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  }
                }
              }
            }
          } else {
            for (let field of requiredFields) {
              if (!item[field]) {
                // 如果字段为空，弹出提示并退出循环
                if (field == "type") {
                  this.$message.info(
                    `科研情况第 ${i + 1} 行的类型没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "xmmc") {
                  this.$message.info(
                    `科研情况第 ${i + 1} 行的文章名称没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "lxdw") {
                  this.$message.info(
                    `科研情况第 ${i + 1} 行的发表期刊没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "lxsj") {
                  this.$message.info(
                    `科研情况第 ${i + 1} 行的发表时间没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                }
              }
            }
          }
        }
      }

      if (!this.ensureList(this.baseInfo.resultlist, "请添加标志性成果"))
        return false;
      if (this.baseInfo.resultlist.length > 0) {
        const requiredFields = ["acquireYear", "title", "levelType"];
        for (let i = 0; i < this.baseInfo.resultlist.length; i++) {
          const item = this.baseInfo.resultlist[i];
          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "acquireYear") {
                this.$message.info(
                  `标志性成果第 ${i + 1} 行的年份没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "title") {
                this.$message.info(
                  `标志性成果第 ${i + 1} 行的成果名称没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "levelType") {
                this.$message.info(
                  `标志性成果第 ${i + 1} 行的级别没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.activitylist, "请添加思政课程与课程思政大格局"))
        return false;
      if (this.baseInfo.activitylist.length > 0) {
        const requiredFields = ["titleName", "szType", "activityYear", "num"];
        const requiredFields2 = [
          "titleName",
          "szType",
          "activityYear",
          "cName",
          "levelType",
          "award",
          "num",
        ];
        const requiredFields3 = [
          "titleName",
          "szType",
          "activityYear",
          "cName",
          "levelType",
          // 'num'
        ];
        const requiredFields5 = [
          "titleName",
          "szType",
          "basicMajorCategory",
          "basicMajorSubclass",
          "basicMajor",
          "activityYear",
          "cName",
          "jkType",
          "levelType",
        ];
        const requiredFields4 = [
          "titleName",
          "szType",
          "basicMajorCategory",
          "basicMajorSubclass",
          "basicMajor",
          "cName",
          "levelType",
          "activityYear",
        ];
        const requiredFields6 = [
          "titleName",
          "szType",
          "basicMajorCategory",
          "basicMajorSubclass",
          "basicMajor",
          "cName",
          "activityYear",
          "levelType",
        ];
        const requiredFields7 = [
          "titleName",
          "szType",
          "activityYear",
          "cName",
          "levelType",
        ];
        for (let i = 0; i < this.baseInfo.activitylist.length; i++) {
          const item = this.baseInfo.activitylist[i];
          // 检查每个字段是否有值
          if (item.titleName && item.titleName == "思政课程开展情况") {
            if (
              item.szType &&
              (item.szType.indexOf("大赛") != -1 ||
                item.szType.indexOf("比赛") != -1 ||
                item.szType.indexOf("竞赛") != -1 ||
                item.szType.indexOf("赛事") != -1)
            ) {
              for (let field of requiredFields2) {
                if (!item[field]) {
                  // 如果字段为空，弹出提示并退出循环
                  if (field == "titleName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的标题名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "szType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的类别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "activityYear") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的年份没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "cName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的赛项名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "levelType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的认定级别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "award") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的奖项没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "num") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的数量没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  }
                }
              }
            } else {
              for (let field of requiredFields3) {
                if (!item[field]) {
                  // 如果字段为空，弹出提示并退出循环
                  if (field == "titleName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的标题名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "szType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的类别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "activityYear") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的年份没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "cName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的课程名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "levelType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的认定级别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  }
                }
              }
            }
          } else if (item.titleName && item.titleName == "课程思政开展情况") {
            if (item.szType && item.szType.indexOf("金课") != -1) {
              for (let field of requiredFields5) {
                if (!item[field]) {
                  // 如果字段为空，弹出提示并退出循环
                  if (field == "titleName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的标题名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "szType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的类别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "activityYear") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的年份没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "basicMajorCategory") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的专业大类没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "basicMajorSubclass") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的专业子类没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "basicMajor") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的专业没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "cName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的课程名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "jkType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的类型没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "levelType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的认定级别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  }
                }
              }
            } else if (item.szType && item.szType.indexOf("精品课") != -1) {
              for (let field of requiredFields4) {
                if (!item[field]) {
                  // 如果字段为空，弹出提示并退出循环
                  if (field == "titleName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的标题名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "szType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的类别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "activityYear") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的年份没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "basicMajorCategory") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的专业大类没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "basicMajorSubclass") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的专业子类没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "basicMajor") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的专业没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "cName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的课程名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "levelType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的认定级别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  }
                }
              }
            } else if (item.szType && item.szType.indexOf("示范课程") != -1) {
              for (let field of requiredFields6) {
                if (!item[field]) {
                  // 如果字段为空，弹出提示并退出循环
                  if (field == "titleName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的标题名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "szType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的类别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "activityYear") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的年份没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "basicMajorCategory") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的专业大类没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "basicMajorSubclass") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的专业子类没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "basicMajor") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的专业没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "cName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的课程名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "levelType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的认定级别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  }
                }
              }
            } else {
              for (let field of requiredFields7) {
                if (!item[field]) {
                  // 如果字段为空，弹出提示并退出循环
                  if (field == "titleName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的标题名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "szType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的类别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "activityYear") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的年份没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "cName") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的案例名称没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  } else if (field == "levelType") {
                    this.$message.info(
                      `思政课程与课程思政大格局第 ${
                        i + 1
                      } 行的认定级别没有值，请填写`
                    );
                    return; // 退出当前函数，停止进一步处理
                  }
                }
              }
            }
          } else {
            for (let field of requiredFields) {
              if (!item[field]) {
                // 如果字段为空，弹出提示并退出循环
                if (field == "activityYear") {
                  this.$message.info(
                    `思政课程与课程思政大格局第 ${i + 1} 行的年份没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "titleName") {
                  this.$message.info(
                    `思政课程与课程思政大格局第 ${
                      i + 1
                    } 行的标题名称没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "szType") {
                  this.$message.info(
                    `思政课程与课程思政大格局第 ${i + 1} 行的类别没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "num") {
                  this.$message.info(
                    `思政课程与课程思政大格局第 ${i + 1} 行的数量没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                }
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.allteacherlist, "请添加团队建设"))
        return false;
      if (this.baseInfo.allteacherlist.length > 0) {
        const requiredFields = ["buildName", "acquireYear", "amount"];
        const requiredFields1 = [
          "buildName",
          "title",
          "acquireYear",
          "teacherName",
          "levelType",
          "award",
        ];
        for (let i = 0; i < this.baseInfo.allteacherlist.length; i++) {
          const item = this.baseInfo.allteacherlist[i];
          // 检查每个字段是否有值
          if (
            item.buildName &&
            (item.buildName.indexOf("大赛") != -1 ||
              item.buildName.indexOf("比赛") != -1 ||
              item.buildName.indexOf("竞赛") != -1 ||
              item.buildName.indexOf("赛事") != -1) &&
            item.buildName.indexOf("青年教师教学基本功比赛") == "-1"
          ) {
            for (let field of requiredFields1) {
              if (!item[field]) {
                // 如果字段为空，弹出提示并退出循环
                if (field == "buildName") {
                  this.$message.info(
                    `团队建设第 ${i + 1} 行的名称没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "title") {
                  this.$message.info(
                    `团队建设第 ${i + 1} 行的大赛名称没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "acquireYear") {
                  this.$message.info(
                    `团队建设第 ${i + 1} 行的年份没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "teacherName") {
                  this.$message.info(
                    `团队建设第 ${i + 1} 行的参赛/指导教师姓名没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "levelType") {
                  this.$message.info(
                    `团队建设第 ${i + 1} 行的类别没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "award") {
                  this.$message.info(
                    `团队建设第 ${i + 1} 行的奖项没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                }
              }
            }
          } else {
            for (let field of requiredFields) {
              if (!item[field]) {
                // 如果字段为空，弹出提示并退出循环
                if (field == "buildName") {
                  this.$message.info(
                    `团队建设第 ${i + 1} 行的名称没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "acquireYear") {
                  this.$message.info(
                    `团队建设第 ${i + 1} 行的年份没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                } else if (field == "amount") {
                  this.$message.info(
                    `团队建设第 ${i + 1} 行的数量没有值，请填写`
                  );
                  return; // 退出当前函数，停止进一步处理
                }
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.baselist, "请添加思政实践基地"))
        return false;
      if (this.baseInfo.baselist.length > 0) {
        const requiredFields = [
          "baseName",
          "baseForm",
          "baseType",
          "cooperativeTime",
          "company",
          "keyWords",
          "acquireYear",
          "subject",
          "peopleNum",
          "address",
        ];
        for (let i = 0; i < this.baseInfo.baselist.length; i++) {
          const item = this.baseInfo.baselist[i];
          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "baseName") {
                this.$message.info(
                  `思政实践基地第 ${i + 1} 行的基地名称没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "baseForm") {
                this.$message.info(
                  `思政实践基地第 ${i + 1} 行的基地形式没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "baseType") {
                this.$message.info(
                  `思政实践基地第 ${i + 1} 行的基地类别没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "cooperativeTime") {
                this.$message.info(
                  `思政实践基地第 ${i + 1} 行的加入时间没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "company") {
                this.$message.info(
                  `思政实践基地第 ${i + 1} 行的合作单位没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "keyWords") {
                this.$message.info(
                  `思政实践基地第 ${i + 1} 行的育人功能关键词没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "acquireYear") {
                this.$message.info(
                  `思政实践基地第 ${i + 1} 行的活动年份没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "subject") {
                this.$message.info(
                  `思政实践基地第 ${i + 1} 行的活动主题没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "peopleNum") {
                this.$message.info(
                  `思政实践基地第 ${i + 1} 行的参与人数没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "address") {
                this.$message.info(
                  `思政实践基地第 ${i + 1} 行的地点没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.honorlist, "请添加荣誉"))
        return false;
      if (this.baseInfo.honorlist.length > 0) {
        const requiredFields = ["honorName", "acquireYear", "amount"];
        for (let i = 0; i < this.baseInfo.honorlist.length; i++) {
          const item = this.baseInfo.honorlist[i];
          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "honorName") {
                this.$message.info(`荣誉第 ${i + 1} 行的名称没有值，请填写`);
                return; // 退出当前函数，停止进一步处理
              } else if (field == "acquireYear") {
                this.$message.info(`荣誉第 ${i + 1} 行的年份没有值，请填写`);
                return; // 退出当前函数，停止进一步处理
              } else if (field == "amount") {
                this.$message.info(`荣誉第 ${i + 1} 行的数量没有值，请填写`);
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.brandlist, "请添加培育品牌"))
        return false;
      if (this.baseInfo.brandlist.length > 0) {
        const requiredFields = ["brandName", "acquireYear", "levelType"];
        for (let i = 0; i < this.baseInfo.brandlist.length; i++) {
          const item = this.baseInfo.brandlist[i];
          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "brandName") {
                this.$message.info(
                  `培育品牌第 ${i + 1} 行的名称没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "acquireYear") {
                this.$message.info(
                  `培育品牌第 ${i + 1} 行的年度没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "levelType") {
                this.$message.info(
                  `培育品牌第 ${i + 1} 行的级别没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      // if (this.$refs.baseInfoRef.fileList.length == 0) {
      //   this.$message.info("请上传申报书");
      //   return false;
      // }
      const params = this.buildStudioImportPayload();
      postAction("/aiAuto/autoImport", params).then((res) => {
        if (res.code == 200) {
          this.isSubmit = true;
          this.$message.success("提交成功");
          this.$router.replace({ name: "szStudio" }).catch(() => {
            this.$router.push({ name: "szStudio" });
          });
          // this.pagination.current=1;
          // this.getData();
          // this.selectedRowKeys = [];
          // this.$forceUpdate();
          console.log("haole");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // goStep(item) {
    //   console.log("item", item);
    //   this.baseInfo = item;
    //   this.editInfo = item;
    // },
    editGo(index) {
      this.activeSection = index;
      this.$nextTick(() => this.refreshSectionFilled());
    },
    editPrev() {
      if (this.activeSection > 0) {
        this.editGo(this.activeSection - 1);
      }
    },
    editNext() {
      if (this.activeSection < this.sections.length - 1) {
        this.editGo(this.activeSection + 1);
      }
    },
    goBack() {
      this.$router.push({ name: "szStudio" });
    },
    isNumber(value) {
      if (/^-?\d+(\.\d+)?$/.test(value)) {
        return value;
      } else {
        return "";
      }
    },
    updateActiveSection() {
      let halfWindowHeight = window.innerHeight * 0.5;
      this.sections.forEach((section, index) => {
        let element = document.getElementById(section.id);
        if (index == this.sections.length - 1) {
          halfWindowHeight = window.innerHeight * 0.7;
        }
        if (
          element.getBoundingClientRect().top <= halfWindowHeight &&
          element.getBoundingClientRect().bottom >= halfWindowHeight
        ) {
          this.activeSection = index;
        }
      });
    },
    isTime(time) {
      if (time === null || time === undefined || time === "") return "";
      const s = String(time).trim().replace(/[/.]/g, "-");
      const m = s.match(/^(20\d{2}|19\d{2})-(\d{1,2})-(\d{1,2})$/);
      if (!m) return "";
      const month = Number(m[2]);
      const day = Number(m[3]);
      if (month < 1 || month > 12 || day < 1 || day > 31) return "";
      return `${m[1]}-${String(month).padStart(2, "0")}-${String(day).padStart(
        2,
        "0"
      )}`;
    },
    /** AI 日期：统一输出 YYYY-MM-DD（仅年份 → YYYY-01-01，年月 → YYYY-MM-01） */
    parseAiDate(val) {
      if (val === null || val === undefined || val === "") return "";
      const s = String(val).trim();
      const full = this.isTime(s);
      if (full) return full;
      // 纯年份
      if (/^\d{4}$/.test(s)) return `${s}-01-01`;
      // 优先匹配年-年区间：2018-2021（避免把 2021 的前两位误当成月份 → 2018-20-01）
      const yearRange = s.match(
        /^(20\d{2}|19\d{2})\s*[-~至到]\s*(20\d{2}|19\d{2})/
      );
      if (yearRange) return `${yearRange[1]}-01-01`;
      // 年月区间：2021.09-2024.09
      const ymRange = s.match(
        /^(20\d{2}|19\d{2})[.\-/](\d{1,2})\s*[-~至到]\s*(20\d{2}|19\d{2})/
      );
      if (ymRange) {
        const month = Number(ymRange[2]);
        if (month >= 1 && month <= 12) {
          return `${ymRange[1]}-${String(month).padStart(2, "0")}-01`;
        }
      }
      // 单年月：2021.09 / 2021-09
      const ym = s.match(/^(20\d{2}|19\d{2})[.\-/](\d{1,2})$/);
      if (ym) {
        const month = Number(ym[2]);
        if (month >= 1 && month <= 12) {
          return `${ym[1]}-${String(month).padStart(2, "0")}-01`;
        }
      }
      // 兜底取首个合法年份
      const yOnly = s.match(/(20\d{2}|19\d{2})/);
      return yOnly ? `${yOnly[1]}-01-01` : "";
    },
    /** 将仅年份/非法日期补全或纠正为合法 YYYY-MM-DD */
    ensureFullDate(val) {
      if (val === null || val === undefined || val === "" || val === "null") {
        return null;
      }
      const s = String(val).trim();
      const full = this.isTime(s);
      if (full) return full;
      // 非法如 2018-20-01：走 parseAiDate 纠正
      const parsed = this.parseAiDate(s);
      return parsed || null;
    },
    isYear(year) {
      if (year === null || year === undefined || year === "") return "";
      if (typeof year === "object" && !Array.isArray(year) && typeof year.year === "function") {
        const y = year.year();
        return y ? String(y) : "";
      }
      if (Array.isArray(year)) {
        for (let i = 0; i < year.length; i++) {
          const y = this.isYear(year[i]);
          if (y) return y;
        }
        return "";
      }
      const s = String(year).trim();
      if (/^\d{4}$/.test(s)) return s;
      // 2021-2024 → 取起始年
      const m = s.match(/(20\d{2}|19\d{2})/);
      if (m) return m[1];
      const d = new Date(year);
      return isNaN(d.getTime()) ? "" : String(d.getFullYear());
    },
    async executeSequentially() {
      try {
        await this.getedu(); // 等待 getedu 执行完成
        // console.log("getedu 执行完毕");

        await this.getzc(); // 等待 getxl 执行完成
        // console.log("getxl 执行完毕");

        await this.getcontent(); // 等待 getcontent 执行完成
        // console.log("getcontent 执行完毕");
        await this.getly();
        // console.log("getly 执行完毕");
        await this.getlb();
        // console.log("getlb 执行完毕");
        await this.getcylist();
        // console.log("getcylist 执行完毕");
        await this.getlxlist();
        //  console.log("getlxlist 执行完毕");
        await this.getkycgjb();
        await this.getbtlist();
        //isbt
        await this.getgb();
        await this.gethzdwlist();
        // console.log("getgb 执行完毕");
        await this.getcgjb();
        //  console.log("getcgjb 执行完毕");
        await this.getjdlb();
        // console.log("getjdlb 执行完毕");
        await this.getjdxs();
        // console.log("getjdxs 执行完毕");
        this.getsj();
      } catch (error) {
        console.log("发生错误:", error);
      }
    },
    // 获取暂存数据
    getTemporaryStorage() {
      postAction("/lx/lxApply/getAiData?applyType=1").then((res) => {
        console.log("res", res);
        if (res.code == 200) {
          this.baseInfo = res.result.jsonObject;
          if (this.baseInfo && this.baseInfo.applyYear) {
            this.baseInfo.applyYear = this.isYear(this.baseInfo.applyYear);
          }
          let fileList = [];
          let fileItem = {};
          fileItem.path = this.baseInfo.declarationPath;
          fileItem.name = this.baseInfo.declarationName;
          fileItem.uid = 1;
          fileList.push(fileItem);
          this.$refs.baseInfoRef.info = this.baseInfo;
          this.$refs.baseInfoRef.fileList = fileList;
          if (this.$refs.baseInfoRef.normalizeApplyYear) {
            this.$refs.baseInfoRef.normalizeApplyYear();
          }
          this.jxing = false;
        }
      });
    },
    getsj() {
      // console.log(sessionStorage.getItem('gzs1'), !sessionStorage.getItem('gzs1'), sessionStorage.getItem('gzs1') == null, "4444");
      if (!sessionStorage.getItem("gzs1")) {
        if (this.$route.query.new == "ai") {
          this.jxing = true;
          if (this.aiChatCancelSource) {
            this.aiChatCancelSource.cancel("restart");
          }
          this.aiChatCancelSource = axios.CancelToken.source();
          postAiChat(
            {
              fileId: this.fileId,
              applyType: 1,
              chatType: this.$route.query.chatType,
              filePath: this.$route.query.filePath,
            },
            { cancelToken: this.aiChatCancelSource.token }
          ).then((res) => {
            //const res = GZS;
            if (res && res.code == 200) {
              // console.log(this.extractJsonContent(str),"22222");
              // this.sj=JSON.parse(this.extractJsonContent(JSON.parse(str).output.choices[0].message.content));
              let str = res.result;
              // console.log(this.extractJsonContent(str),"22222");
              // console.log(this.extractJsonContent(str));
              // this.sj = JSON.parse(this.extractJsonContent(str));
              this.sj = str;
              // console.log(this.sj);

              let datas = {
                name: "",
                applyYear: "",
                address: "",
                acreage: "",
                belongDepartment: "",
                foundTime: "",
                tsSzgzsKnow: "",
                tsSzgzsSatisfied: "",
                reportNum: "",
                conmunicateNum: "",
                teacherlist: [],
                applyType: 1,
                capitalBudgetinglist: [],
                capitalPaylist: [],
                resultlist: [],
                activitylist: [],
                allteacherlist: [],
                baselist: [],
                honorlist: [],
                brandlist: [],
                declarationName: "",
                declarationPath: "",
                teachreserchlist: [],
                sciencelist: [],
              };
              // console.log(this.sj,"444444");
              datas.name = this.sj.工作室基本信息.工作室名称;
              datas.applyYear = this.sj.工作室基本信息.申报年份
                ? this.isYear(this.sj.工作室基本信息.申报年份)
                : "";
              datas.address = this.sj.工作室基本信息.工作室地点
                ? this.sj.工作室基本信息.工作室地点
                : "";
              datas.acreage = this.sj.工作室基本信息.场所面积
                ? this.sj.工作室基本信息.场所面积
                : "";
              datas.belongDepartment = this.sj.工作室基本信息.所属部门
                ? this.sj.工作室基本信息.所属部门
                : "";
              datas.foundTime = this.sj.工作室基本信息.建设日期
                ? emptyToNull(this.parseAiDate(this.sj.工作室基本信息.建设日期))
                : null;
              datas.tsSzgzsKnow = this.sj.工作室基本信息.全校师生对工作室知晓度
                ? this.sj.工作室基本信息.全校师生对工作室知晓度
                : "";
              datas.tsSzgzsSatisfied = this.sj.工作室基本信息
                .全校师生对工作室服务满意度
                ? this.sj.工作室基本信息.全校师生对工作室服务满意度
                : "";
              datas.reportNum = this.sj.工作室基本信息
                .项目被省级或国家级媒体报道次数
                ? this.sj.工作室基本信息.项目被省级或国家级媒体报道次数
                : "";
              datas.conmunicateNum = this.sj.工作室基本信息
                .省内外同类院校前来交流学习次数
                ? this.sj.工作室基本信息.省内外同类院校前来交流学习次数
                : "";
              datas.declarationName = this.$route.query.fileName;
              datas.declarationPath = this.$route.query.filePath;
              if (this.sj.工作室团队 && this.sj.工作室团队.length > 0) {
                datas.teacherlist = this.sj.工作室团队.reduce(
                  (accumulator, student, index) => {
                    accumulator.push({
                      teacherName:
                        student.教师姓名 == undefined ? "" : student.教师姓名,
                      id: student.教师姓名 + index,
                      sex: student.性别 == undefined ? "男" : student.性别,
                      education:
                        student.学历 == undefined
                          ? ""
                          : this.isedu(student.学历),
                      professionalTitle:
                        student.职称 == undefined
                          ? ""
                          : this.iszc(student.职称),
                      engagedContent:
                        student.从事内容 == undefined
                          ? ""
                          : this.iscontent(student.从事内容),
                      joinYear:
                        student.加入年份 == undefined
                          ? ""
                          : this.isYear(student.加入年份),
                      primaryMission:
                        student.主要任务 == undefined ? "" : student.主要任务,
                      izResponse:
                        student.是否负责人 == undefined
                          ? "否"
                          : student.是否负责人,
                      izDedicated:
                        student.是否专岗 == undefined ? "否" : student.是否专岗,
                      izPolitical:
                        student.是否思政教师 == undefined
                          ? "否"
                          : student.是否思政教师,
                      szMemberSource:
                        student.成员来源 == undefined
                          ? ""
                          : this.iscyly(student.成员来源),
                      izBsxw:
                        student.是否取得博士学位 == undefined
                          ? "否"
                          : student.是否取得博士学位,
                      bsTime:
                        student.是否取得博士学位 == undefined ||
                        student.是否取得博士学位 === "否"
                          ? student.在读博士入学时间 == undefined
                            ? null
                            : emptyToNull(this.isTime(student.在读博士入学时间))
                          : student.是否取得博士学位 === "是"
                          ? student.获得博士学位时间 == undefined
                            ? null
                            : emptyToNull(this.isTime(student.获得博士学位时间))
                          : null,
                      phone:
                        student.联系方式 == undefined ? "否" : student.联系方式,
                    });

                    return accumulator;
                  },
                  []
                );
              }
              if (this.sj.教研情况 && this.sj.教研情况.length > 0) {
                datas.teachreserchlist = this.sj.教研情况.reduce(
                  (accumulator, student, index) => {
                    accumulator.push({
                      id: "教研情况" + index,
                      year:
                        student.年份 == undefined
                          ? ""
                          : this.isYear(student.年份),
                      num:
                        student.次数 == undefined
                          ? ""
                          : this.isNumber(student.次数),
                    });

                    return accumulator;
                  },
                  []
                );
              }
              if (this.sj.工作室资金预算 && this.sj.工作室资金预算.length > 0) {
                datas.capitalBudgetinglist = this.sj.工作室资金预算.reduce(
                  (accumulator, student, index) => {
                    accumulator.push({
                      capitalSource:
                        student.资金来源 == undefined
                          ? ""
                          : this.isly(student.资金来源)[0],
                      id:
                        this.isly(student.资金来源)[0] +
                        student.资金金额 +
                        index,
                      amount:
                        student.资金金额 == undefined
                          ? ""
                          : this.isNumber(student.资金金额),
                      vintages:
                        student.年份 == undefined
                          ? ""
                          : this.isYear(student.年份),
                    });
                    return accumulator;
                  },
                  []
                );
              }
              if (this.sj.工作室资金支出 && this.sj.工作室资金支出.length > 0) {
                datas.capitalPaylist = this.sj.工作室资金支出.reduce(
                  (accumulator, student, index) => {
                    accumulator.push({
                      lxSubsudyFundId:
                        student.支出资金来源 == undefined
                          ? ""
                          : this.isly(student.支出资金来源)[0],
                      costYear:
                        student.支出年份 == undefined
                          ? ""
                          : this.isYear(student.支出年份),
                      amount:
                        student.支出金额 == undefined
                          ? ""
                          : this.isNumber(student.支出金额),
                      project:
                        student.支出项目 == undefined ? "" : student.支出项目,
                      id: student.支出项目 + index,
                    });
                    return accumulator;
                  },
                  []
                );
              }

              if (this.sj.科研情况 && this.sj.科研情况.length > 0) {
                datas.sciencelist = this.sj.科研情况.reduce(
                  (accumulator, student, index) => {
                    const isProject =
                      student.类型 &&
                      student.类型.indexOf("项目完成数") != "-1";
                    const isArticle =
                      student.类型 &&
                      student.类型.indexOf("项目完成数") == "-1";
                    accumulator.push({
                      type:
                        student.类型 == undefined
                          ? ""
                          : this.islx(student.类型),
                      xmmc: isProject
                        ? student.项目名称 == undefined
                          ? ""
                          : student.项目名称
                        : isArticle
                        ? student.文章名称 == undefined
                          ? ""
                          : student.文章名称
                        : student.项目名称 == undefined
                        ? student.文章名称 == undefined
                          ? ""
                          : student.文章名称
                        : student.项目名称,
                      lxdw: isProject
                        ? student.立项单位 == undefined
                          ? ""
                          : student.立项单位
                        : isArticle
                        ? student.发表期刊 == undefined
                          ? ""
                          : student.发表期刊
                        : student.立项单位 == undefined
                        ? student.发表期刊 == undefined
                          ? ""
                          : student.发表期刊
                        : student.立项单位,
                      // 发表篇数：lxsj 对应发表时间；无值传 null，避免后端日期字段收 "" 失败
                      lxsj: isProject
                        ? emptyToNull(
                            student.立项时间 == undefined
                              ? ""
                              : this.parseAiDate(student.立项时间)
                          )
                        : isArticle
                        ? emptyToNull(
                            student.发表时间 == undefined
                              ? ""
                              : this.parseAiDate(student.发表时间)
                          )
                        : emptyToNull(
                            student.立项时间 == undefined
                              ? student.发表时间 == undefined
                                ? ""
                                : this.parseAiDate(student.发表时间)
                              : this.parseAiDate(student.立项时间)
                          ),
                      // 发表篇数无结项时间，必须传 null 而非 ""
                      jxsj: isProject
                        ? emptyToNull(
                            student.结项时间 == undefined ||
                              student.结项时间 === ""
                              ? student.立项时间 == undefined
                                ? ""
                                : this.parseAiDate(student.立项时间)
                              : this.parseAiDate(student.结项时间)
                          )
                        : null,
                      xnjb: isProject
                        ? student.项目级别 == undefined
                          ? ""
                          : this.iskyjb(student.项目级别)
                        : null,
                      zzje: isProject
                        ? (() => {
                            const n =
                              student.资助金额 == undefined ||
                              student.资助金额 === ""
                                ? 0
                                : this.isNumber(student.资助金额);
                            return n === "" ? 0 : Number(n) / 10000;
                          })()
                        : null,
                      // 与教研情况一致：用稳定唯一 id，避免同类型/缺字段导致 rowKey 冲突，批量移除误删全部
                      id: "科研情况" + index,
                    });
                    return accumulator;
                  },
                  []
                );
              }
              if (this.sj.标志性成果 && this.sj.标志性成果.length > 0) {
                datas.resultlist = this.sj.标志性成果.reduce(
                  (accumulator, student, index) => {
                    accumulator.push({
                      title:
                        student.成果名称 == undefined ? "" : student.成果名称,
                      acquireYear:
                        student.年份 == undefined
                          ? ""
                          : this.isYear(student.年份),
                      amount:
                        student.数量 == undefined
                          ? ""
                          : this.isNumber(student.数量),
                      levelType:
                        student.级别 == undefined
                          ? ""
                          : this.isgb(student.级别)[0],
                      otherType:
                        student.级别 == undefined
                          ? ""
                          : this.isgb(student.级别)[1],
                      id: student.成果名称 + index,
                    });
                    return accumulator;
                  },
                  []
                );
              }
              if (
                this.sj.思政课程与课程思政大格局 &&
                this.sj.思政课程与课程思政大格局.length > 0
              ) {
                datas.activitylist = this.sj.思政课程与课程思政大格局.reduce(
                  (accumulator, student, index) => {
                    accumulator.push({
                      titleName:
                        student.标题名称 == undefined
                          ? ""
                          : this.isbt(student.标题名称),
                      szType: student.类别 == undefined ? "" : student.类别,
                      otherTypee: "",
                      basicMajorCategory: "",
                      basicMajorSubclass: "",
                      basicMajor: "",
                      cName: student.名称 == undefined ? "" : student.名称,
                      jkType:
                        student.类型 == undefined
                          ? ""
                          : this.isjk(student.类型),
                      levelType:
                        student.认定级别 == undefined
                          ? ""
                          : this.isgb(student.认定级别)[0],
                      otherLevelType:
                        student.认定级别 == undefined
                          ? ""
                          : this.isgb(student.认定级别)[1],
                      award: student.奖项 == undefined ? "" : student.奖项,
                      activityYear:
                        student.年份 == undefined
                          ? ""
                          : this.isYear(student.年份),
                      num:
                        student.数量 == undefined
                          ? ""
                          : this.isNumber(student.数量),
                      id: student.数量 + index,
                    });
                    return accumulator;
                  },
                  []
                );
              }
              if (this.sj.团队建设 && this.sj.团队建设.length > 0) {
                datas.allteacherlist = this.sj.团队建设.reduce(
                  (accumulator, student, index) => {
                    console.log(student.级别, "444");
                    accumulator.push({
                      buildName:
                        student.名称 == undefined
                          ? ""
                          : this.ismc(student.名称)[0],
                      otherType:
                        student.名称 == undefined
                          ? ""
                          : this.ismc(student.名称)[1],
                      id: this.ismc(student.名称)[0] + "团队建设" + index,
                      acquireYear:
                        student.年份 == undefined
                          ? ""
                          : this.isYear(student.年份),
                      amount:
                        student.数量 == undefined
                          ? ""
                          : this.isNumber(student.数量),
                      title:
                        student.大赛名称 == undefined ? "" : student.大赛名称,
                      teacherName:
                        student.指导教师姓名 == undefined
                          ? ""
                          : student.指导教师姓名,
                      levelType:
                        student.级别 == undefined
                          ? ""
                          : this.isgb(student.级别)[0],
                      otherLevelType:
                        student.级别 == undefined
                          ? ""
                          : this.isgb(student.级别)[1],
                      award: student.奖项 == undefined ? "" : student.奖项,
                    });
                    return accumulator;
                  },
                  []
                );
              }
              if (this.sj.思政实践基地 && this.sj.思政实践基地.length > 0) {
                datas.baselist = this.sj.思政实践基地.reduce(
                  (accumulator, student, index) => {
                    accumulator.push({
                      baseName:
                        student.基地名称 == undefined ? "" : student.基地名称,
                      baseForm:
                        student.基地形式 == undefined
                          ? ""
                          : this.isjdxs(student.基地形式),
                      baseType:
                        student.基地类别 == undefined
                          ? ""
                          : this.isjdlb(student.基地类别),
                      cooperativeTime:
                        student.加入时间 == undefined
                          ? null
                          : emptyToNull(this.isTime(student.加入时间)),
                      company:
                        student.合作单位 == undefined
                          ? ""
                          : this.ishzdw(student.合作单位)[0],
                      otherCompany:
                        student.合作单位 == undefined
                          ? ""
                          : this.ishzdw(student.合作单位)[1],
                      keyWords:
                        student.育人功能关键词 == undefined
                          ? ""
                          : student.育人功能关键词,
                      subject:
                        student.活动主题 == undefined ? "" : student.活动主题,
                      address: student.地点 == undefined ? "" : student.地点,
                      peopleNum:
                        student.参与人次 == undefined
                          ? ""
                          : this.isNumber(student.参与人次),
                      acquireYear:
                        student.活动年份 == undefined
                          ? ""
                          : this.isYear(student.活动年份),
                      id: student.基地名称 + index,
                    });
                    return accumulator;
                  },
                  []
                );
              }
              if (this.sj.荣誉 && this.sj.荣誉.length > 0) {
                datas.honorlist = this.sj.荣誉.reduce(
                  (accumulator, student, index) => {
                    accumulator.push({
                      honorName: student.名称 == undefined ? "" : student.名称,
                      id: student.名称 + index,
                      acquireYear:
                        student.年份 == undefined
                          ? ""
                          : this.isYear(student.年份),
                      amount:
                        student.数量 == undefined
                          ? ""
                          : this.isNumber(student.数量),
                    });
                    return accumulator;
                  },
                  []
                );
              }
              if (this.sj.培育品牌 && this.sj.培育品牌.length > 0) {
                datas.brandlist = this.sj.培育品牌.reduce(
                  (accumulator, student, index) => {
                    accumulator.push({
                      brandName: student.名称 == undefined ? "" : student.名称,
                      id: student.名称 + index,
                      acquireYear:
                        student.年度 == undefined
                          ? ""
                          : this.isYear(student.年度),
                      levelType:
                        student.级别 == undefined
                          ? ""
                          : this.isgb(student.级别)[0],
                      otherLevelType:
                        student.级别 == undefined
                          ? ""
                          : this.isgb(student.级别)[1],
                    });
                    return accumulator;
                  },
                  []
                );
              }
              // this.editInfo=datas;
              this.baseInfo = datas;
              // console.log(this.baseInfo,'99999999999999999999999999999999999999999999999999999')
              sessionStorage.setItem("gzs1", JSON.stringify(this.baseInfo));
              // console.log(this.baseInfo, "xiang");
            } else {
              this.$message.error(
                (res && res.message) || "智能识别失败，请稍后重试"
              );
              this.$router.go(-1);
            }
          })
          .catch((err) => {
            if (axios.isCancel(err)) {
              return;
            }
            console.error("AI识别失败:", err);
            const msg =
              (err && err.message) ||
              (err &&
                err.response &&
                err.response.data &&
                err.response.data.message) ||
              "智能识别失败，请稍后重试";
            this.$message.error(msg);
            this.$router.go(-1);
          })
          .finally(() => {
            this.aiChatCancelSource = null;
            this.jxing = false;
          });
        }
      } else {
        this.jxing = false;
        console.log(sessionStorage.getItem("gzs1"));
        this.baseInfo = JSON.parse(sessionStorage.getItem("gzs1"));
      }
    },
    cancelAiParse() {
      if (this.aiChatCancelSource) {
        this.aiChatCancelSource.cancel("user_cancel");
        this.aiChatCancelSource = null;
      }
      this.jxing = false;
      this.$message.info("已取消智能识别");
      this.$router.go(-1);
    },
  },
  mounted() {
    this.fileId = this.$route.query.id;
    // console.log(this.editInfo,'我是editInfo');
    // if (this.editInfo !== null) {
    //   console.log("this.editInfo mounted", this.editInfo);
    //   this.baseInfo = this.editInfo;
    //   this.id = this.editInfo.id;
    // this.$refs.baseInfoRef.info = this.editInfo;
    // this.$refs.teamInfoRef.oldInfo = this.editInfo;
    // console.log("this.$refs.baseInfoRef.info", this.$refs.baseInfoRef);
    // // this.$refs.baseInfoRef.info = this.editInfo;
    // this.$refs.teamInfoRef.oldInfo = this.editInfo;
    // this.$refs.budgetRef.oldInfo = this.editInfo;
    // this.$refs.capitalExpenditureRef.oldInfo = this.editInfo;
    // this.$refs.resultRef.oldInfo = this.editInfo;
    // this.$refs.teamBuildingRef.oldInfo = this.editInfo;
    // this.$refs.practiceBaseRef.oldInfo = this.editInfo;
    // this.$refs.honorRef.oldInfo = this.editInfo;
    // this.$refs.brandRef.oldInfo = this.editInfo;
    // }
    this.isAdd = this.$route.query.new;
    // 有id 是ai导入  无id 是暂存数据
    if (this.$route.query.new == "ai" && this.$route.query.id) {
      this.executeSequentially();
    } else {
      this.getTemporaryStorage();
    }
  },

  beforeDestroy() {
    // sessionStorage.removeItem('gzs1');
    sessionStorage.setItem("gzs1", "");
    if (this.aiChatCancelSource) {
      this.aiChatCancelSource.cancel("leave");
      this.aiChatCancelSource = null;
    }
    const params = {
      jsonObject: this.syncAiFormData ? this.syncAiFormData() : this.baseInfo,
    };
    if (!this.isSubmit) {
      postAction("/lx/lxApply/saveAiData?applyType=1", params).then((res) => {
        if (res.code == 200) {
          //this.$message.success("暂存成功");
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/components/projectShell/updatePage.scss";

.ps-update-page.is-ai-parsing {
  min-height: 560px;
  position: relative;
}
</style>